<!-- eslint-disable vue/max-attributes-per-line -->
<template>
  <a-modal :title="viewtTtle" :visible="showZoneUserView" width="66%" :footer="null" destroyOnClose @ok="closeView"
    @cancel="closeView" style="position: absolute; left: 18rem; z-index: 999; top: 10rem">
    <a-button :loading="exportLoading" class="export-btn" @click="exportHandle()">
      <a-icon type="download" />导出
    </a-button>

    <a-table size="middle" rowKey="id" bordered :data-source="list" :columns="columns" :pagination="pagination"
      @change="pageChange" :scroll="{ x: 1500 }">
      <a-tag color="blue" slot="waterBigStatus" slot-scope="text">{{ text === 1 ? '用水大户' : '普通用户' }}</a-tag>
      <span slot="createTime" slot-scope="text">{{ text | moment }}</span>
    </a-table>
  </a-modal>
</template>
<script>
import axios from 'axios'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import storage from 'store'
export default {

  components: {

  },
  data () {
    return {
      exportLoading: false,
      showZoneUserView: false,
      viewtTtle: '',
      pagination: {
        orderType: 'asc',
        zoneId: '',
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: (total) => `共 ${total} 条记录`,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100', '1000', '5000']
      },
      queryUrl: 'pipe-network/zone-metering/get/zone/waterMeter/user',
      query: {
        sysType: true,
        tenantId: this.$store.state.user.info.tenantId
      },
      list: [],
      columns: [
        {
          title: '片区名称',
          dataIndex: 'zoneName',
          width: 120,
          ellipsis: true
        },
        {
          title: '用户编码',
          dataIndex: 'userNo',
          width: 120,
          ellipsis: true
        },
        {
          title: '分类编码',
          dataIndex: 'classNo',
          width: 120,
          ellipsis: true
        },
        {
          title: '水表编号',
          dataIndex: 'appearanceNo',
          width: 120,
          ellipsis: true
        },
        {
          title: '用户名称',
          dataIndex: 'userNikeName',
          width: 120,
          ellipsis: true
        },
        {
          title: '通信编号',
          dataIndex: 'commNumber',
          width: 120,
          ellipsis: true
        },
        {
          title: '用户地址',
          dataIndex: 'address',
          width: 150,
          ellipsis: true
        },
        {
          title: '手机号',
          dataIndex: 'phone',
          width: 120,
          ellipsis: true
        },
        {
          title: '安装时间',
          dataIndex: 'installDate',
          width: 120,
          ellipsis: true
        },
        {
          title: '口径',
          dataIndex: 'caliber',
          width: 80,
          ellipsis: true
        },
        {
          title: '品牌',
          dataIndex: 'brand',
          width: 100,
          ellipsis: true
        },
        {
          title: '类型',
          dataIndex: 'type',
          width: 100,
          ellipsis: true
        },
        {
          title: '状态',
          dataIndex: 'status',
          width: 80,
        },
        {
          title: '用户用水类型',
          dataIndex: 'waterBigStatus',
          width: 120,
          scopedSlots: { customRender: 'waterBigStatus' }
        }
      ],
      needPage: true, // 是否需要分页
      name: '',
      zoneId: '',
      exportDataUrl: 'pipe-network/zone-metering/export',

    }
  },
  methods: {
    exportHandle () {
      //导出片区下终端用户信息Excel
      this.exportLoading = true
      const token = storage.get(ACCESS_TOKEN)
      const params = {
        responseType: 'arraybuffer',
        params: {
          orderColumn: '',
          orderType: 'asc',
          sysType: true,
          zoneId: this.zoneId,
          page: this.pagination.current,
          limit: this.pagination.pageSize
        },
        headers: {
          Authorization: token
        }
      }
      const url = `${process.env.VUE_APP_API_BASE_URL}${this.exportDataUrl}`
      axios
        .get(url, params)
        .then((res) => {
          const blob = new Blob([res.data], { type: 'application/octet-stream;charset=utf-8' })
          const fileName = this.exportFileName || '片区终端用户信息导出数据.xls'
          const eLink = document.createElement('a')
          eLink.download = fileName
          eLink.style.display = 'none'
          eLink.href = URL.createObjectURL(blob)
          document.body.appendChild(eLink)
          eLink.click()
          URL.revokeObjectURL(eLink.href)
          document.body.removeChild(eLink)
          this.$message.success('导出完成')
          this.exportLoading = false
        })
        .catch(() => {
          this.exportLoading = false
        })
    },
    pageChange (pagination, filters, sorter) {

      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.getDataLists()
    },
    getDataList (name, zoneId) {
      this.name = name;
      this.zoneId = zoneId;
      this.pagination.current = 1
      this.pagination.pageSize = 10
      this.getDataLists();
    },
    // 获取数据
    getDataLists () {
      const that = this
      const params = {
        orderColumn: '',
        orderType: 'asc',
        sysType: true,
        zoneId: this.zoneId,
        page: that.pagination.current,
        limit: that.pagination.pageSize
      }
      this.$http
        .get(that.queryUrl, { params })
        .then(({ data }) => {
          if (that.needPage) {
            that.list = data.list || []
            that.pagination.total = data.total ? parseInt(data.total) : 0
            if (data.total > 0) {
              that.isadd = false
            } else {
              that.isadd = true
            }
          } else {
            that.list = data
          }
        })
        .catch(() => {

        })
      this.viewtTtle = `用户列表【${this.name}】`
      this.showZoneUserView = true
    },
    closeView () {
      this.showZoneUserView = false
    }
  }
}
</script>

<style lang="less" scoped>
.export-btn {
  position: absolute;
  top: 11px;
  right: 60px;
  z-index: 10;
  background-color: #ffffff;
  border-color: #0890f2;
  color: #0890f2;

  &:hover,
  &:focus {
    background-color: #e6f7ff;
    border-color: #0890f2;
    color: #0890f2;
  }

  &:active {
    background-color: #bae7ff;
    border-color: #0890f2;
    color: #0890f2;
  }
}

/deep/ .ant-modal-header {
  color: #fff;
  background: #0d7ccd;
  border-radius: 8px 8px 0 0;
  padding: 18px 24px;
  background-image: linear-gradient(270deg, rgba(8, 144, 242, 0.5) 0%, #0890f2 100%);
}

/deep/ .ant-modal-title {
  color: #fff;
  line-height: 16px;
}

/deep/ .ant-modal-content {
  border-radius: 8px;
  opacity: 0.9;
}

/deep/ .ant-modal-body {
  padding: 24px;
}

/deep/ .ant-modal-close-x {
  color: #eee6e6;
  line-height: 50px;
  font-size: 16px;

  &:hover {
    color: #ffffff;
  }
}

/deep/ .ant-modal {
  top: 150px;
}

/deep/ .ant-table {
  .ant-table-thead>tr>th {
    background-color: #fafafa;
    font-weight: 600;
    white-space: nowrap;
    text-align: center;
  }

  .ant-table-tbody>tr>td {
    white-space: nowrap;
    text-align: center;
  }
}

/deep/ .ant-select-selection--single {
  color: #000000a6 !important;
  background-color: #ffffff !important;
}

/deep/ .ant-select-arrow {
  color: #000000a6 !important;
}

/deep/ .ant-select-sm .ant-select-selection__rendered {
  line-height: 34px !important;
}
</style>
